module.exports = __webpack_public_path__ + "static/media/amazonRev.6795eb91.png";